import React from 'react'

export const PrizeColumn = ({ prizes, direction, speed }) => {
  const animationDuration = `${prizes.length * 15}s`; // Increased duration for slower scrolling

  return (
    <div className="h-full overflow-hidden">
      <div 
        className={`flex flex-col gap-12 animate-scroll`} // Increased gap between items
        style={{
          animationDuration,
          animationDirection: direction === 'up' ? 'reverse' : 'normal'
        }}
      >
        {[...prizes, ...prizes].map((prize, index) => (
          <div key={index} className="relative mx-auto w-1/2 animate-pulse-zoom"> {/* Reduced width for better 4-column fit */}
            <img
              src={prize.image}
              alt={prize.name}
              className="w-full h-auto rounded-lg p-4" // Added padding
            />
            <div className="absolute inset-0 flex items-center justify-center">
              <div className="bg-black bg-opacity-70 px-3 py-2 rounded-lg"> {/* Increased padding */}
                <h3 className="text-white text-lg font-bold text-center"> {/* Further reduced text size */}
                  {prize.name}
                </h3>
              </div>
            </div>
          </div>
        ))}
      </div>
    </div>
  )
}
